import { useEffect, useState } from "react";
import {
  FormData,
  FormErrors,
  TouchedFields,
  ProjectFormProps,
  SelectOption,
} from "../../common/types";

import {
  handleBlur,
  validate,
  validateField,
} from "../../../utils/Validations/formValidationUtils";

import { MultiValue } from "react-select";
import { handleFormSubmit } from "../../../utils/FormSubmit/formSubmitUtils";
import { styled } from "styled-components";

import {
  endAlignment,
  ErrorMessage,
  inputContainerStyle,
  InputStyled,
} from "./contactForm";
import { capitalizeFirstLetter } from "../../../utils/UtilityFunctions";
import Squarebtn from "../Squarebtn";

const CenterForm = styled.div`
  margin: 1.5rem 0;
  display: flex;
  justify-content: center;
  align-items: cemter;
`;

const ProjectForm: React.FC<ProjectFormProps> = ({
  showAlert,
  showLoader,
  projectName,
}) => {
  //initial project form data
  const [formData, setFormData] = useState<Partial<FormData>>({
    email: "",
    message: "",
    projectName: projectName,
  });

    // Sync projectName prop with formData
    useEffect(() => {
      setFormData((prev) => ({ ...prev, projectName }));
    }, [projectName]);

  //initial project form errors
  const [errors, setErrors] = useState<Partial<FormErrors>>({});

  //initial touch state
  const [touched, setTouched] = useState<Partial<TouchedFields>>({});

  const handleChange = (
    e: React.ChangeEvent<
      HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement
    >
  ) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });

    if (touched[name as keyof typeof touched]) {
      // console.log("Input Value", value);
      validateFieldWrapper(name as keyof FormData, value);
    }
  };

  const handleBlurWrapper = (name: keyof Partial<FormData>, value: string) => {
    handleBlur(name, value, touched, setTouched, validateFieldWrapper);
  };

  const validateFieldWrapper = (
    name: keyof Partial<FormData>,
    value: string | MultiValue<SelectOption>
  ) => {
    validateField(name, value, errors, setErrors);
  };

  const validateWrapper = () => validate(formData, errors, setErrors, setTouched);

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();

    handleFormSubmit({
      formData,
      validateWrapper,
      showLoader,
      showAlert,
      setFormData,
      setTouched,
    });
  };

  return (
    <>
      <CenterForm>
        <form onSubmit={handleSubmit} className="App-form-style">
          <p style={{fontWeight: 500}}>Want a deeper dive?</p>
          <p className="containTextInParagraphs">Get in touch if you have any questions about {formData.projectName}.</p>
          <div style={inputContainerStyle}>
            <label htmlFor="email">Email</label>
            <InputStyled
              type="email"
              id="email"
              autoComplete="email"
              name="email"
              placeholder="Enter your email"
              value={formData.email}
              onChange={handleChange}
              onBlur={() => handleBlurWrapper("email", formData.email ?? "")}
              $errorColor={errors.email? "red": ""}
            />
            {errors.email && (
              <ErrorMessage>{capitalizeFirstLetter(errors.email)}</ErrorMessage>
            )}
          </div>

          <div style={inputContainerStyle}>
            <label htmlFor="message">Message</label>
            <InputStyled
              as="textarea"
              id="message"
              name="message"
              placeholder={`Enter your message about ${formData.projectName}`}
              value={formData.message}
              onChange={handleChange}
              onBlur={() =>
                handleBlurWrapper("message", formData.message ?? "")
              }
              style={{ height: "150px" }}
              $errorColor={errors.message? "red": ""}
            />
            {errors.message && (
              <ErrorMessage>
                {capitalizeFirstLetter(errors.message)}
              </ErrorMessage>
            )}
          </div>

          <div style={endAlignment}>
            <Squarebtn type="submit" height="50px" width="120px">
              Shoot
            </Squarebtn>
          </div>
        </form>
      </CenterForm>
    </>
  );
};

export default ProjectForm;
